(function () {
  const SECTION_SELECTOR = ".influencer-videos";
  const VIDEO_SELECTOR = "video[data-video-lazy]";

  function loadVideo(video) {
    video.querySelectorAll("source").forEach(function (source) {
      const src = source.getAttribute("data-src");

      if (src && !source.src) {
        source.src = src;
      }

      source.removeAttribute("data-src");
    });

    video.load();
    video.removeAttribute("data-video-lazy");

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(function () {});
    }
  }

  function initLazyVideos(root) {
    const videos = Array.from(
      (root || document).querySelectorAll(
        SECTION_SELECTOR + " " + VIDEO_SELECTOR,
      ),
    );

    if (!videos.length) return;

    if (!("IntersectionObserver" in window)) {
      videos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          loadVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "300px 0px" },
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initLazyVideos();
    });
  } else {
    initLazyVideos();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initLazyVideos(event.target);
  });
})();
